import axios from "axios";

export default {
  props: {
    background: {
      type: String,
      required: false,
      default: () => null
    },
    title: {
      type: String,
      required: false,
      default: () => "newsletter.subscribe_to_avm"
    },
    btnLabel: {
      type: String,
      required: false,
      default: () => "Únete"
    }
  },
  data: () => ({
    appConfig: window.appConfig,
    form: {
      valid: false,
      email: {
        value: null,
        rules: [
          v => !!v || "Debes introducir un e-mail",
          v => /.+@.+/.test(v) || "El e-mail introducido no es válido"
        ],
      }
    },
    newsubscriber: '',
    message: '',
    loading: false,
  }),
  methods: {
    submitForm() {
      if(this.form.valid){
        let url = '/api/newsubscriber';
        let that = this;
        let email = that.form.email.value;
        let appConfig = this.appConfig;

        this.loading = true;

        axios.get(url , { params: {email: email, appConfig: appConfig} }).then(function (response) {
          that.message = response.data.message;
          that.form.email.value = '';
          that.newsubscriber = true;
          setTimeout(() => {
            that.newsubscriber = false;
          }, 5000);
        })
        .catch(function (error) {
            // handle error
            console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
      }else{
        console.log('error');
      }
    }
  }
};
